bq.tokenizerTokenex = function (element, options) {
    this.options = options;
    this.$element = $(element);
    this.$hiddenInput = $('#' + this.options.bqCvvTokenizedInputId);
    this.$parentForm = $(this.options.parentFormSelector);
    this.tokenizeTriggerAction = this.options.tokenizeTriggerAction;
    this.iframe = false;
    this.detokenizeLinkEnabled = true;
    this.defaultValidation = {
        processed: false,
        valid: false,
        response: {}
    };
    this.defaultTokenization = {
        processed: false,
        response: {}
    };

    this.validation = $.extend({}, this.defaultValidation);
    this.tokenization = $.extend({}, this.defaultTokenization);
};

bq.tokenizerTokenex.DEFAULTS = {};

bq.tokenizerTokenex.prototype = {
    init: function () {
        this._loadScript();
        this.$element.on('bq.tokenizer.createIframe', {context: this}, this._createIframe.bind(this));
        this.$element.on('bq.tokenizer.tokenize', {context: this}, this._tokenize.bind(this));
        this.$element.on('bq.tokenizer.createIframeAndDetokenize', {context: this}, this._createIframeAndDetokenize.bind(this));
    },

    _loadScript: function() {
        var tokenexScript = document.getElementById('tokenexScript');
        if (!tokenexScript) {
            var script = document.createElement('script');
            if (!this.options.bqScriptUrl) {
                bq.debug.error('data-bq-script-url is required');
                return;
            }

            var debugState = bq.debugState || false;
            var bqScriptUrl = this.options.bqScriptUrl
            script.src = debugState ? bqScriptUrl.replace('.min.js','.js') : bqScriptUrl;
            script.id = 'tokenexScript';
            document.body.appendChild(script);
        }
    },

    _createIframe: function(event, afterCreateCallback) {
        var $this = typeof event === 'undefined' ? this : event.data.context;
        var intervalIndex = 0;
        var tokenexLoadingTimeout = setInterval(function() {
            if (typeof TokenEx === 'object') {
                clearInterval(tokenexLoadingTimeout);
                if (!$this.options.tokenizeCvvIframeDivId) {
                    bq.debug.error('Container id of CVV iframe is required');
                    return;
                }
                if (!$this.options.tokenizeCardId || !$this.options.tokenizeCardHash) {
                    bq.debug.error('Options tokenizeCardId and tokenizeCardHash are required');
                    return;
                }

                var cardType = $this.options.tokenizeCardType || '';

                var tokenizeCvvConfigData = {
                    cardId: $this.options.tokenizeCardId,
                    hash: $this.options.tokenizeCardHash
                };

                $.post($this.options.tokenizeCvvUrl, tokenizeCvvConfigData)
                    .done(function(response) {
                        response = JSON.parse(response);
                        if (!response.error) {
                            var styles = {
                                base: "font-family: Arial, sans-serif;padding: 0 8px;border: 1px solid rgba(0, 0, 0, 0.2);margin: 0;width: 100%;font-size: 13px;line-height: 30px;height: 32px;box-sizing: border-box;-moz-box-sizing: border-box; text-align:center;",
                                focus: "box-shadow: 0 0 6px 0 rgba(0, 132, 255, 0.5);border: 1px solid rgba(0, 132, 255, 0.5);outline: 0;",
                                error: "box-shadow: 0 0 6px 0 rgba(224, 57, 57, 0.5);border: 1px solid rgba(255, 0, 0, 1);",
                            };

                            var debugState = bq.debugState || false;

                            var iframeConfig = $.extend(
                                {},
                                response.config.config.iframeConfig,
                                { styles: styles, cardType: cardType, debug: debugState }
                            );

                            if ($this.iframe) {
                                $this.iframe.remove();
                            }
                            $this.iframe = new TokenEx.Iframe($this.options.tokenizeCvvIframeDivId, iframeConfig);

                            $this.iframe.on('load', function () {
                                $this._clearHiddenInput();
                                $this.iframe.validate();
                            });
                            $this.iframe.on('change', $this.validate.bind($this));
                            $this.iframe.on('validate', $this._handleValidationResult.bind($this));
                            $this.iframe.on('tokenize', $this._handleTokenizeResult.bind($this));
                            $(document).on('bq.paymentMethods.preSubmit', function() {
                                $this._clearHiddenInput();
                                $this.iframe.tokenize();
                            });

                            $this.iframe.load();

                            afterCreateCallback();
                        }
                    });
            }

            if (intervalIndex > 10) {
                clearInterval(tokenexLoadingTimeout);
                return;
            }
        },500);
    },

    _createIframeAndDetokenize: function(event) {

        var $this = this;
        if (!$this.detokenizeLinkEnabled) {
            return;
        }

        if (!$this.options.detokenizeConfigUrl) {
            bq.debug.error('"data-detokenize-config-url" is required');
            return;
        }

        if (!$this.options.detokenizeCardId || !$this.options.detokenizeCardToken) {
            bq.debug.error('"data-detokenize-card-id" and "data-detokenize-card-hash" are required');
            return;
        }

        var detokenizeConfigData = {
            card_id: $this.options.detokenizeCardId,
            pan_token: $this.options.detokenizeCardToken,
            cvv_token:$this.options.detokenizeCvvToken
        };

        $.post($this.options.detokenizeConfigUrl, detokenizeConfigData)
            .done(function(response) {
                response = JSON.parse(response);

                if (response.error) {
                    bq.debug.error(response.error);
                    return;
                }

                var styles = {
                    base: "font-family: Arial, sans-serif;padding: 0 8px;margin: 0;width: 100%;height:100%;font-size: 13px;line-height: 32px;height: 32px;box-sizing: border-box;-moz-box-sizing: border-box; text-align:center;",
                    focus: "box-shadow: 0 0 6px 0 rgba(0, 132, 255, 0.5);outline: 0;",
                    error: "box-shadow: 0 0 6px 0 rgba(224, 57, 57, 0.5);border: 1px solid rgba(255, 0, 0, 1);",
                    cvv: {
                        base: "font-family: Arial, sans-serif;padding: 0 8px;margin: 0;width: 100%;height:100%;font-size: 13px;line-height: 32px;height: 32px;box-sizing: border-box;-moz-box-sizing: border-box; text-align:center;",
                        focus: "box-shadow: 0 0 6px 0 rgba(0, 132, 255, 0.5);outline: 0;",
                        error: "box-shadow: 0 0 6px 0 rgba(224, 57, 57, 0.5);border: 1px solid rgba(255, 0, 0, 1);",
                    }
                }

                var iframeNumberConfig = $.extend({}, response.config.config.iframeConfig, { styles: styles });
                var iframeCvvConfig = $.extend({}, response.config.config.cvvIframeConfig, { styles: styles });

                if ($this.iframe) {
                    $this.iframe.remove();
                }
                if ($this.cvvIframe) {
                    $this.cvvIframe.remove();
                }
                $this.iframe = new TokenEx.DetokenizeIframe( $this.options.detokenizeIframeCardNumDivId, iframeNumberConfig );
                $this.iframe.on('load', function() {
                    $('#' + $this.options.detokenizeIframeCardNumDivId + ' .unclear-text').hide();
                    $this.disableLink();
                });
                $this.iframe.on('expired', function() {
                    $('#' + $this.options.detokenizeIframeCardNumDivId + ' .unclear-text').show();
                    $this.enableLink();
                });
                $this.iframe.on('error', function(){ console.log('Iframe Error: ' + JSON.stringify(arguments)) });
                $this.iframe.load();

                $this.cvvIframe = new TokenEx.DetokenizeIframe( iframeCvvConfig.cvvContainerID, iframeCvvConfig );
                $this.cvvIframe.on('load', function() {
                    $('#' + iframeCvvConfig.cvvContainerID + ' .unclear-text').hide();
                    $this.disableLink();
                });
                $this.cvvIframe.on('expired', function() {
                    $('#' + iframeCvvConfig.cvvContainerID + ' .unclear-text').show();
                    $this.enableLink();
                });
                $this.cvvIframe.on('error', function(){ console.log('Iframe Error: ' + JSON.stringify(arguments)) });
                $this.cvvIframe.load();
                $this.sendClickDecrementRequest();
            });
    },

    sendClickDecrementRequest: function() {
        var $this = this;
        $.post($this.options.detokenizeDecrementOrderClickUrl, {order_id: $this.options.detokenizeOrderId})
            .done(function(response) {
                response = JSON.parse(response);
                if (response.error) {
                    bq.debug.error(response.error);
                    return;
                }
                if (!response.token_uses_left) {
                    $('a[data-detokenize-card-id='+$this.options.detokenizeCardId+']').hide();
                }
            });
    },

    disableLink: function() {
        this.$element.addClass('disabled');
        this.detokenizeLinkEnabled = false;
    },

    enableLink: function() {
        this.$element.removeClass('disabled');
        this.detokenizeLinkEnabled = true;
    },

    _tokenize: function(e, callback) {
        var $this = e.data.context;
        $this.iframe.tokenize();
        if ($this.requestTimeout) {
            clearInterval($this.requestTimeout);
        }

        var intervalIndex = 0;
        $this.requestTimeout = setInterval(function() {
            intervalIndex ++;

            if (intervalIndex > 20) {
                clearInterval($this.requestTimeout);
                callback({
                    error: true,
                    response: {
                        message: 'TimeOut'
                    }
                });

                return;
            }

            if ($this.validation.processed) {
                clearInterval($this.requestTimeout);
                let result = $this.validation.valid ? {error: false} : {error: true, response: {}};
                callback(result);
            }
        }.bind(this), 500);
    },

    validate: function() {
        this.iframe.validate();
    },

    _handleValidationResult: function(data) {
        this.validation = {
            processed: true,
            valid: data.isValid,
            response: data
        };

        if (!this.validation.valid) {
            this._updateHiddenInput('', true);
        }

        bq.debug.info("CC CVV iframe validation response:" + JSON.stringify(data));
    },

    _handleTokenizeResult: function(data) {
        this.tokenization.processed = true;
        this.tokenization.response = data;
        bq.debug.info("CC CVV iframe tokenization response:" + JSON.stringify(data));
        this._updateHiddenInput(data.token, true);
    },

    _updateHiddenInput: function(value, shouldTriggerAction) {
        this.$hiddenInput.val(value);
        if (shouldTriggerAction) {
            this.$parentForm.trigger(this.tokenizeTriggerAction, this.$hiddenInput);
        }
    },

    _clearHiddenInput: function() {
        bq.debug.info("Clearing hidden CVV field:" + this.$hiddenInput.prop('id'));
        this.$hiddenInput.val(null);
    }
};

$.fn.tokenizerTokenex = function (option) {
    return this.each(function () {
        var $this = $(this);
        var data = $this.data('bq.tokenizerTokenex');
        if (!data) {
            var options = $.extend({}, bq.tokenizerTokenex.DEFAULTS, $this.data(), typeof (option) === 'object' && option);
            $this.data('bq.tokenizerTokenex', (data = new bq.tokenizerTokenex(this, options)));
        }
        data.init();
    });
};

$.fn.tokenizerTokenex.Constructor = bq.tokenizerTokenex;

bq.tokenizerTokenexInit = function () {
    $('[data-bq="tokenizer-tokenex"]').each(function () {
        var $el = $(this);
        if ($el.data('bq.tokenizerTokenex')) {
            return;
        }
        $el.tokenizerTokenex($el.data());
    });
};

bq.init.push(bq.tokenizerTokenexInit);
